import { useParams } from "react-router-dom";
import SelfEvaluationInfoForm from "./Form/SelfEvaluationInfoForm";
import { SelfEvaluationInfoProvider } from "./Form/SelfEvaluationInfoContext";

const SelfEvaluationInfo = () => {
    const { id, id2 } = useParams();

    return (
        <SelfEvaluationInfoProvider key={id}>
            <SelfEvaluationInfoForm />
        </SelfEvaluationInfoProvider>
    );
};

export default SelfEvaluationInfo;